import { config } from "../config";

const VISITOR_KEY = "lh_visitor_id";
const TRACKED_KEY = "lh_tracked";

// Generate a UUID. Prefer crypto.randomUUID (secure contexts), fall back for old browsers.
function generateId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// Returns { visitorId, isNew }. isNew is true only the first time this browser is seen.
export function getVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_KEY);
  let isNew = false;
  if (!visitorId) {
    visitorId = generateId();
    localStorage.setItem(VISITOR_KEY, visitorId);
    isNew = true;
  }
  return { visitorId, isNew };
}

// POST a single visit per tab session. Never throws — tracking must not break the UI.
export async function trackVisit() {
  try {
    if (sessionStorage.getItem(TRACKED_KEY)) return;

    const { visitorId, isNew } = getVisitorId();
    const payload = {
      visitorId,
      isNew,
      path: window.location.pathname,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      language: navigator.language,
      screen: `${window.screen.width}x${window.screen.height}`,
      ts: new Date().toISOString(),
    };

    await fetch(`${config.serverApi}/trackVisit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    sessionStorage.setItem(TRACKED_KEY, "1");
  } catch (err) {
    console.debug("visitor tracking failed", err);
  }
}
